export default {
    en: 'En',
    fr: 'Fr',
};
